import { useState, useEffect } from "react";
import { Form, Button, Col, Row } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faUserPlus,
  faUserPen,
  faGraduationCap,
  faUser,
  faHouse,
  faHeartPulse,
  faSchool,
  faUsers,
  faStar,
  faFolderOpen,
  faCamera,
  faSave,
  faArrowRight,
  faArrowLeft,
  faFilePdf,
  faCheckCircle,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { APIUS } from "../../../../../../config/apius";
import { APIMS } from "../../../../../../config/apims";
import LoaderAction from "../../../../../Loader/LoaderHome";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import "bulma/css/bulma.css";
import "../../../../../../index.css";

const INITIAL_FORM = {
  ysb_branch_id: "",
  ysb_school_id: "",
  ysb_semester_id: "",
  ysb_academic_year_id: "",
  kelas: "",
  tahun_ajaran: "",
  tahun_ajaran_pindahan: "",
  semester: "",
  kode_absen: "",
  order_absen: "",
  nama_lengkap: "",
  nama_alias: "",
  email_siswa: "",
  email_murid: "",
  jenis_kelamin: "",
  nisn: "",
  nis_ypi: "",
  no_portal: "",
  nik: "",
  no_kk: "",
  tempat_lahir: "",
  tanggal_lahir_siswa: "",
  agama: "",
  kewarnegaraan: "WNI",
  anak_ke: "",
  jumlah_saudara_kandung: "",
  bahasa_dirumah: "",
  alamat_lengkap: "",
  provinsi: "",
  kota_kabupaten: "",
  kecamatan: "",
  kelurahan: "",
  kode_pos: "",
  warga_summarecon: "",
  jarak_rumah_sekolah: "",
  waktu_tempuh_sekolah: "",
  ke_sekolah_dengan: "",
  tinggi: "",
  berat: "",
  linkar_kepala: "",
  ukuran_sepatu: "",
  penyakit_diderita: "",
  kelainan_jasmani: "",
  pernah_dirawat_di: "",
  sekolah_asal: "",
  nama_sekolah_asal: "",
  akreditasi_sekolah_asal: "",
  provinsi_asal: "",
  kota_kabupaten_asal: "",
  kecamatan_asal: "",
  kelurahan_desa_asal: "",
  kode_pos_asal: "",
  pindahan_dari_sekolah: "",
  syarat_1: 0,
  syarat_2: 0,
  syarat_3: 0,
  syarat_4: 0,
  nama_lengkap_ayah: "",
  nik_ayah: "",
  tempat_lahir_ayah: "",
  tanggal_lahir_ayah: "",
  kewarganegaraan_ayah: "WNI",
  pendidikan_terakhir_ayah: "",
  pekerjaan_ayah: "",
  penghasilan_ayah: "",
  no_handphone_ayah: "",
  alamat_email_ayah: "",
  keterangan_ayah: "",
  nama_lengkap_ibu: "",
  nik_ibu: "",
  tempat_lahir_ibu: "",
  tanggal_lahir_ibu: "",
  kewarnegaraan_ibu: "WNI",
  pekerjaan_ibu: "",
  penghasilan_ibu: "",
  no_handphone_ibu: "",
  alamat_email_ibu: "",
  keterangan_ibu: "",
  bidang_akademik: "",
  kesenian: "",
  pendidikan_jasmani: "",
  lain_lain: "",
  saudara_kandung_di_sekolah: "",
  internet: 0,
  billboard: 0,
  teman: 0,
  pameran: 0,
  rekomendasi_asal_sekolah: 0,
  spanduk: 0,
  keluarga: 0,
  foto_siswa: "",
  file_akte_kelahiran: "",
  file_kartu_keluarga: "",
  file_ktp_orang_tua: "",
  file_raport: "",
  file_surat_keterangan_asal_sekolah: "",
};

const INITIAL_FILES = {
  file_akte_kelahiran: null,
  file_kartu_keluarga: null,
  file_ktp_orang_tua: null,
  file_raport: null,
  file_surat_keterangan_asal_sekolah: null,
  foto_siswa: null,
};

const TABS = [
  { id: "akademik", label: "1. Akademik & Filter", icon: faGraduationCap },
  { id: "siswa", label: "2. Data Pribadi Siswa", icon: faUser },
  { id: "domisili", label: "3. Tempat Tinggal", icon: faHouse },
  { id: "kesehatan", label: "4. Fisik & Kesehatan", icon: faHeartPulse },
  { id: "asal_sekolah", label: "5. Asal Sekolah", icon: faSchool },
  { id: "orang_tua", label: "6. Data Orang Tua", icon: faUsers },
  { id: "lainnya", label: "7. Informasi Lain", icon: faStar },
  { id: "berkas", label: "8. Upload Berkas", icon: faFolderOpen },
  { id: "foto", label: "9. Foto Siswa", icon: faCamera },
];

const DOC_FIELDS = [
  { name: "file_akte_kelahiran", label: "Akta Kelahiran", desc: "Format: PDF, JPG, PNG (Maks. 5MB)" },
  { name: "file_kartu_keluarga", label: "Kartu Keluarga", desc: "Format: PDF, JPG, PNG (Maks. 5MB)" },
  { name: "file_ktp_orang_tua", label: "KTP Orang Tua", desc: "Format: PDF, JPG, PNG (Maks. 5MB)" },
  { name: "file_raport", label: "Raport Terakhir", desc: "Format: PDF, JPG, PNG (Maks. 5MB)" },
  { name: "file_surat_keterangan_asal_sekolah", label: "Surat Keterangan Asal Sekolah", desc: "Format: PDF, JPG, PNG (Maks. 5MB)" },
];

export default function ModalPendaftaranUpdate(props) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("akademik");

  const [branches, setBranches] = useState([]);
  const [schools, setSchools] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);
  const [loadingGradeLevel, setLoadingGradeLevel] = useState(false);
  const [semesters, setSemesters] = useState([]);

  const [form, setForm] = useState(INITIAL_FORM);
  const [files, setFiles] = useState(INITIAL_FILES);
  const [photoPreview, setPhotoPreview] = useState(null);

  const safeValue = (val) => (val !== null && val !== undefined ? val : "");

  const fetchParams = {
    headers: { Authorization: String(token), "Content-Type": "application/json" },
  };

  useEffect(() => {
    const loadInitialFilters = async () => {
      try {
        const [resBranches, resSemesters] = await Promise.all([
          APIMS.get("/api/branches?page=0&limit=100&ascending=0&search=", fetchParams).catch(() => null),
          APIMS.get("/api/semesters?page=1&limit=1000&ascending=1&search=", fetchParams).catch(() => null),
        ]);

        if (resBranches?.data?.data) {
          setBranches(resBranches.data.data);
        }
        if (resSemesters?.data?.data) {
          const semesterList = resSemesters.data.data;
          setSemesters(semesterList);
        }
      } catch (e) {
        console.error("Gagal memuat opsi filter:", e);
      }
    };

    if (props.show) {
      setActiveTab("akademik");
      setFiles(INITIAL_FILES);
      loadInitialFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    if (props?.dataUpdate) {
      const d = props.dataUpdate;
      setForm({
        ysb_branch_id: safeValue(d.ysb_branch_id),
        ysb_school_id: safeValue(d.ysb_school_id),
        ysb_grade_level_id: safeValue(d.ysb_grade_level_id),
        ysb_semester_id: safeValue(d.ysb_semester_id),
        ysb_academic_year_id: safeValue(d.ysb_academic_year_id),
        kelas: safeValue(d.kelas),
        tahun_ajaran: safeValue(d.tahun_ajaran),
        tahun_ajaran_pindahan: safeValue(d.tahun_ajaran_pindahan),
        semester: safeValue(d.semester),
        kode_absen: safeValue(d.kode_absen),
        order_absen: safeValue(d.order_absen),
        nama_lengkap: safeValue(d.nama_lengkap),
        nama_alias: safeValue(d.nama_alias),
        email_siswa: safeValue(d.email_siswa),
        email_murid: safeValue(d.email_murid),
        jenis_kelamin: safeValue(d.jenis_kelamin),
        nisn: safeValue(d.nisn),
        nis_ypi: safeValue(d.nis_ypi),
        no_portal: safeValue(d.no_portal),
        nik: safeValue(d.nik),
        no_kk: safeValue(d.no_kk),
        tempat_lahir: safeValue(d.tempat_lahir),
        tanggal_lahir_siswa: safeValue(d.tanggal_lahir_siswa),
        agama: safeValue(d.agama),
        kewarnegaraan: safeValue(d.kewarnegaraan) || "WNI",
        anak_ke: safeValue(d.anak_ke),
        jumlah_saudara_kandung: safeValue(d.jumlah_saudara_kandung),
        bahasa_dirumah: safeValue(d.bahasa_dirumah),
        alamat_lengkap: safeValue(d.alamat_lengkap),
        provinsi: safeValue(d.provinsi),
        kota_kabupaten: safeValue(d.kota_kabupaten),
        kecamatan: safeValue(d.kecamatan),
        kelurahan: safeValue(d.kelurahan),
        kode_pos: safeValue(d.kode_pos),
        warga_summarecon: safeValue(d.warga_summarecon),
        jarak_rumah_sekolah: safeValue(d.jarak_rumah_sekolah),
        waktu_tempuh_sekolah: safeValue(d.waktu_tempuh_sekolah),
        ke_sekolah_dengan: safeValue(d.ke_sekolah_dengan),
        tinggi: safeValue(d.tinggi),
        berat: safeValue(d.berat),
        linkar_kepala: safeValue(d.linkar_kepala),
        ukuran_sepatu: safeValue(d.ukuran_sepatu),
        penyakit_diderita: safeValue(d.penyakit_diderita),
        kelainan_jasmani: safeValue(d.kelainan_jasmani),
        pernah_dirawat_di: safeValue(d.pernah_dirawat_di),
        sekolah_asal: safeValue(d.sekolah_asal),
        nama_sekolah_asal: safeValue(d.nama_sekolah_asal),
        akreditasi_sekolah_asal: safeValue(d.akreditasi_sekolah_asal),
        provinsi_asal: safeValue(d.provinsi_asal),
        kota_kabupaten_asal: safeValue(d.kota_kabupaten_asal),
        kecamatan_asal: safeValue(d.kecamatan_asal),
        kelurahan_desa_asal: safeValue(d.kelurahan_desa_asal),
        kode_pos_asal: safeValue(d.kode_pos_asal),
        pindahan_dari_sekolah: safeValue(d.pindahan_dari_sekolah),
        syarat_1: Number(d.syarat_1) || 0,
        syarat_2: Number(d.syarat_2) || 0,
        syarat_3: Number(d.syarat_3) || 0,
        syarat_4: Number(d.syarat_4) || 0,
        nama_lengkap_ayah: safeValue(d.nama_lengkap_ayah),
        nik_ayah: safeValue(d.nik_ayah),
        tempat_lahir_ayah: safeValue(d.tempat_lahir_ayah),
        tanggal_lahir_ayah: safeValue(d.tanggal_lahir_ayah),
        kewarganegaraan_ayah: safeValue(d.kewarganegaraan_ayah) || "WNI",
        pendidikan_terakhir_ayah: safeValue(d.pendidikan_terakhir_ayah),
        pekerjaan_ayah: safeValue(d.pekerjaan_ayah),
        penghasilan_ayah: safeValue(d.penghasilan_ayah),
        no_handphone_ayah: safeValue(d.no_handphone_ayah),
        alamat_email_ayah: safeValue(d.alamat_email_ayah),
        keterangan_ayah: safeValue(d.keterangan_ayah),
        nama_lengkap_ibu: safeValue(d.nama_lengkap_ibu),
        nik_ibu: safeValue(d.nik_ibu),
        tempat_lahir_ibu: safeValue(d.tempat_lahir_ibu),
        tanggal_lahir_ibu: safeValue(d.tanggal_lahir_ibu),
        kewarnegaraan_ibu: safeValue(d.kewarnegaraan_ibu) || "WNI",
        pekerjaan_ibu: safeValue(d.pekerjaan_ibu),
        penghasilan_ibu: safeValue(d.penghasilan_ibu),
        no_handphone_ibu: safeValue(d.no_handphone_ibu),
        alamat_email_ibu: safeValue(d.alamat_email_ibu),
        keterangan_ibu: safeValue(d.keterangan_ibu),
        bidang_akademik: safeValue(d.bidang_akademik),
        kesenian: safeValue(d.kesenian),
        pendidikan_jasmani: safeValue(d.pendidikan_jasmani),
        lain_lain: safeValue(d.lain_lain),
        saudara_kandung_di_sekolah: safeValue(d.saudara_kandung_di_sekolah),
        internet: Number(d.internet) || 0,
        billboard: Number(d.billboard) || 0,
        teman: Number(d.teman) || 0,
        pameran: Number(d.pameran) || 0,
        rekomendasi_asal_sekolah: Number(d.rekomendasi_asal_sekolah) || 0,
        spanduk: Number(d.spanduk) || 0,
        keluarga: Number(d.keluarga) || 0,
        foto_siswa: safeValue(d.foto_siswa),
        file_akte_kelahiran: safeValue(d.file_akte_kelahiran),
        file_kartu_keluarga: safeValue(d.file_kartu_keluarga),
        file_ktp_orang_tua: safeValue(d.file_ktp_orang_tua),
        file_raport: safeValue(d.file_raport),
        file_surat_keterangan_asal_sekolah: safeValue(d.file_surat_keterangan_asal_sekolah),
      });

      if (d.foto_siswa) {
        const baseUrl = process.env.REACT_APP_US || "";
        setPhotoPreview(`${baseUrl}/storage/${d.foto_siswa}`);
      } else {
        setPhotoPreview(null);
      }

      if (d.ysb_branch_id) {
        APIMS.get(
          "/api/schools?page=0&limit=100&ascending=0&search=&ascending_name=true&branch=" + d.ysb_branch_id,
          fetchParams
        )
          .then((res) => {
            if (res?.data?.data) {
              setSchools(res.data.data);
            }
          })
          .catch(() => setSchools([]));
      } else {
        setSchools([]);
      }

      if (d.ysb_school_id) {
        setLoadingGradeLevel(true);
        const storageLevel = localStorage.getItem("level") || "";
        APIMS.get(
          `/api/grade-levels?page=1&limit=1000&ascending=1&branch=${d.ysb_branch_id || ""}&ysb_school_id=${d.ysb_school_id}&level=${storageLevel}`,
          fetchParams
        )
          .then((res) => {
            if (res?.data?.data) {
              let levels = res.data.data.filter((x) => {
                const sid = x?.ysb_school_id ?? null;
                if (!sid) return true;
                return String(sid) === String(d.ysb_school_id);
              });
              levels = [...levels].sort((a, b) =>
                String(a?.name_level || "").localeCompare(String(b?.name_level || ""), "id", {
                  sensitivity: "base",
                })
              );
              setGradeLevels(levels);
            }
          })
          .catch(() => setGradeLevels([]))
          .finally(() => setLoadingGradeLevel(false));
      } else {
        setGradeLevels([]);
      }
    }
  }, [props?.dataUpdate]);

  const handleBranchChange = async (branchId) => {
    setForm((prev) => ({
      ...prev,
      ysb_branch_id: branchId,
      ysb_school_id: "",
      ysb_grade_level_id: "",
    }));
    setSchools([]);
    setGradeLevels([]);

    if (!branchId) return;

    try {
      const res = await APIMS.get(
        "/api/schools?page=0&limit=100&ascending=0&search=&ascending_name=true&branch=" + branchId,
        fetchParams
      );
      if (res?.data?.data) {
        setSchools(res.data.data);
      }
    } catch (e) {
      setSchools([]);
    }
  };

  const handleSchoolChange = async (schoolId) => {
    setForm((prev) => ({
      ...prev,
      ysb_school_id: schoolId,
      ysb_grade_level_id: "",
    }));
    setGradeLevels([]);

    if (!schoolId) return;

    setLoadingGradeLevel(true);
    try {
      const storageLevel = localStorage.getItem("level") || "";
      const branchId = form.ysb_branch_id || "";
      const res = await APIMS.get(
        `/api/grade-levels?page=1&limit=1000&ascending=1&branch=${branchId}&ysb_school_id=${schoolId}&level=${storageLevel}`,
        fetchParams
      );

      if (res?.status === 200) {
        let levels = res.data.data || [];

        levels = levels.filter((x) => {
          const sid = x?.ysb_school_id ?? null;
          if (!sid) return true;
          return String(sid) === String(schoolId);
        });

        levels = [...levels].sort((a, b) =>
          String(a?.name_level || "").localeCompare(String(b?.name_level || ""), "id", {
            sensitivity: "base",
          })
        );

        setGradeLevels(levels);
      }
    } catch (err) {
      console.error("Gagal mengambil data tingkatan:", err);
      setGradeLevels([]);
    } finally {
      setLoadingGradeLevel(false);
    }
  };

  const handleSemesterChange = (semesterId) => {
    const selected = semesters.find((s) => String(s?.id) === String(semesterId));
    setForm((prev) => ({
      ...prev,
      ysb_semester_id: semesterId,
      ysb_academic_year_id: selected?.ysb_academic_year_id || "",
      tahun_ajaran: selected?.name_year || prev.tahun_ajaran,
      semester: selected?.semester ? String(selected.semester) : prev.semester,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles[0]) {
      setFiles((prev) => ({ ...prev, [name]: selectedFiles[0] }));
    }
  };

  const handlePhotoChange = (e) => {
    const { files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles[0]) {
      const file = selectedFiles[0];
      setFiles((prev) => ({ ...prev, foto_siswa: file }));
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handleRemovePhoto = () => {
    setFiles((prev) => ({ ...prev, foto_siswa: null }));
    if (form.foto_siswa) {
      const baseUrl = process.env.REACT_APP_US || "";
      setPhotoPreview(`${baseUrl}/storage/${form.foto_siswa}`);
    } else {
      setPhotoPreview(null);
    }
  };

  const handleNextTab = () => {
    const currentIndex = TABS.findIndex((t) => t.id === activeTab);
    if (currentIndex < TABS.length - 1) {
      setActiveTab(TABS[currentIndex + 1].id);
    }
  };

  const handlePrevTab = () => {
    const currentIndex = TABS.findIndex((t) => t.id === activeTab);
    if (currentIndex > 0) {
      setActiveTab(TABS[currentIndex - 1].id);
    }
  };

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (
          form[key] !== null &&
          form[key] !== undefined &&
          !key.startsWith("file_") &&
          key !== "foto_siswa"
        ) {
          formData.append(key, form[key]);
        }
      });

      // Attach file uploads
      if (files.file_akte_kelahiran) {
        formData.append("file_akte_kelahiran", files.file_akte_kelahiran);
      }
      if (files.file_kartu_keluarga) {
        formData.append("file_kartu_keluarga", files.file_kartu_keluarga);
      }
      if (files.file_ktp_orang_tua) {
        formData.append("file_ktp_orang_tua", files.file_ktp_orang_tua);
      }
      if (files.file_raport) {
        formData.append("file_raport", files.file_raport);
      }
      if (files.file_surat_keterangan_asal_sekolah) {
        formData.append("file_surat_keterangan_asal_sekolah", files.file_surat_keterangan_asal_sekolah);
      }
      if (files.foto_siswa) {
        formData.append("foto_siswa", files.foto_siswa);
      }

      const uploadHeaders = {
        headers: {
          Authorization: String(token),
          "Content-Type": "multipart/form-data",
        },
      };

      const response = await APIUS.post(`/api/students/update/${props.id}`, formData, uploadHeaders);
      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message || "Data siswa berhasil diperbarui",
        });
        props.GetResponseData?.();
        props.onHide();
      }
    } catch (error) {
      swal({
        title: "Gagal Memperbarui Data",
        text: error?.response?.data?.message || error.message || "Terjadi kesalahan",
        icon: "error",
        timer: 10000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  });

  return (
    <div className="modal">
      {loading && <LoaderAction />}

      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        scrollable
      >
        <Modal.Header
          className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom"
          style={{ backgroundColor: "#ffffff" }}
        >
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                backgroundColor: "#e8f0fe",
                color: "#1a73e8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <FontAwesomeIcon icon={faUserPen} size="lg" />
            </div>
            <div>
              <h5 className="modal-title font-weight-bold mb-0 text-dark" style={{ fontSize: "18px" }}>
                Perbarui Data Siswa
              </h5>
              <small className="text-muted" style={{ fontSize: "12px" }}>
                Perbarui informasi siswa Al-Azhar secara lengkap
              </small>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-light rounded-circle p-2"
            onClick={props.onHide}
            style={{ width: "36px", height: "36px", border: "1px solid #e0e0e0" }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="p-4" style={{ backgroundColor: "#f8f9fa", maxHeight: "75vh" }}>
          {/* TAB NAVIGATION */}
          <div
            className="d-flex flex-wrap align-items-center p-2 bg-white rounded-3 shadow-sm mb-4"
            style={{
              gap: "6px",
              border: "1px solid #eef0f2",
            }}
          >
            {TABS.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className="btn d-flex align-items-center gap-2"
                  style={{
                    borderRadius: "8px",
                    padding: "6px 11px",
                    fontSize: "12.5px",
                    fontWeight: isActive ? "600" : "500",
                    backgroundColor: isActive ? "#1a73e8" : "transparent",
                    color: isActive ? "#ffffff" : "#5f6368",
                    border: "none",
                    transition: "all 0.2s ease-in-out",
                    whiteSpace: "nowrap",
                  }}
                >
                  <FontAwesomeIcon icon={tab.icon} />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>

          <Form onSubmit={(e) => handleSubmit.mutate(e)}>
            {/* TAB 1: AKADEMIK & FILTER */}
            {activeTab === "akademik" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faGraduationCap} /> Informasi Akademik & Penempatan
                </h6>
                <Row className="g-3">
                  <Col md="12">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tahun Ajaran & Semester <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="ysb_semester_id"
                        value={form.ysb_semester_id}
                        onChange={(e) => handleSemesterChange(e.target.value)}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        required
                      >
                        <option value="">Pilih Tahun Ajaran & Semester</option>
                        {semesters.map((sem) => (
                          <option key={sem.id} value={sem.id}>
                            {sem.name_year} (Semester {sem.semester})
                            {Number(sem.status) === 1 ? " • Aktif" : ""}
                          </option>
                        ))}
                      </select>
                      <small className="text-muted" style={{ fontSize: "11px" }}>
                        Memilih semester otomatis menetapkan Tahun Ajaran & Semester ID
                      </small>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Cabang
                      </label>
                      <select
                        className="form-select"
                        name="ysb_branch_id"
                        value={form.ysb_branch_id}
                        onChange={(e) => handleBranchChange(e.target.value)}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">Pilih Cabang</option>
                        {branches.map((b) => (
                          <option key={b.id} value={b.id}>
                            {b.branch_name || b.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Sekolah
                      </label>
                      <select
                        className="form-select"
                        name="ysb_school_id"
                        value={form.ysb_school_id}
                        onChange={(e) => handleSchoolChange(e.target.value)}
                        disabled={!form.ysb_branch_id || schools.length === 0}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">
                          {!form.ysb_branch_id
                            ? "Pilih Cabang terlebih dahulu"
                            : schools.length === 0
                            ? "Tidak ada sekolah pada cabang ini"
                            : "Pilih Sekolah"}
                        </option>
                        {schools.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.school_name || s.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tingkatan
                      </label>
                      <select
                        className="form-select"
                        name="ysb_grade_level_id"
                        value={form.ysb_grade_level_id}
                        onChange={handleChange}
                        disabled={!form.ysb_school_id || loadingGradeLevel}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">
                          {!form.ysb_school_id
                            ? "Pilih Sekolah terlebih dahulu"
                            : loadingGradeLevel
                            ? "Memuat data tingkatan..."
                            : "Pilih Tingkatan"}
                        </option>
                        {!loadingGradeLevel &&
                          gradeLevels.map((gl, index) => (
                            <option key={gl.id || index} value={gl.id}>
                              {gl.name_level || gl.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kode Absen
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kode_absen"
                        value={form.kode_absen}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Urutan Absen
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="order_absen"
                        value={form.order_absen}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tahun Ajaran Pindahan
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="tahun_ajaran_pindahan"
                        value={form.tahun_ajaran_pindahan}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* TAB 2: DATA PRIBADI SISWA */}
            {activeTab === "siswa" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faUser} /> Identitas & Data Pribadi Siswa
                </h6>
                <Row className="g-3">
                  <Col md="6">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Nama Lengkap <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nama_lengkap"
                        value={form.nama_lengkap}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        required
                      />
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Nama Panggilan / Alias
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nama_alias"
                        value={form.nama_alias}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Email Siswa
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email_siswa"
                        value={form.email_siswa}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="6">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Jenis Kelamin
                      </label>
                      <select
                        className="form-select"
                        name="jenis_kelamin"
                        value={form.jenis_kelamin}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">Pilih Jenis Kelamin</option>
                        <option value="Laki-laki">Laki-laki</option>
                        <option value="Perempuan">Perempuan</option>
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        NISN
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nisn"
                        value={form.nisn}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        NIS YPI
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nis_ypi"
                        value={form.nis_ypi}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        NIK (Siswa)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nik"
                        value={form.nik}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        No. Kartu Keluarga (KK)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="no_kk"
                        value={form.no_kk}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        No. Portal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="no_portal"
                        value={form.no_portal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tempat Lahir
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="tempat_lahir"
                        value={form.tempat_lahir}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tanggal Lahir
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="tanggal_lahir_siswa"
                        value={form.tanggal_lahir_siswa}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Agama
                      </label>
                      <select
                        className="form-select"
                        name="agama"
                        value={form.agama}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">Pilih Agama</option>
                        <option value="Islam">Islam</option>
                        <option value="Kristen">Kristen</option>
                        <option value="Katolik">Katolik</option>
                        <option value="Hindu">Hindu</option>
                        <option value="Buddha">Buddha</option>
                        <option value="Konghucu">Konghucu</option>
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kewarganegaraan
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kewarnegaraan"
                        value={form.kewarnegaraan}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Anak Ke-
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="anak_ke"
                        value={form.anak_ke}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Jumlah Saudara Kandung
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="jumlah_saudara_kandung"
                        value={form.jumlah_saudara_kandung}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Bahasa di Rumah
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="bahasa_dirumah"
                        value={form.bahasa_dirumah}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* TAB 3: TEMPAT TINGGAL */}
            {activeTab === "domisili" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faHouse} /> Alamat Tempat Tinggal & Transportasi
                </h6>
                <Row className="g-3">
                  <Col md="12">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Alamat Lengkap
                      </label>
                      <textarea
                        className="form-control"
                        name="alamat_lengkap"
                        rows="2"
                        value={form.alamat_lengkap}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Provinsi
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="provinsi"
                        value={form.provinsi}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kota / Kabupaten
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kota_kabupaten"
                        value={form.kota_kabupaten}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kecamatan
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kecamatan"
                        value={form.kecamatan}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kelurahan / Desa
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kelurahan"
                        value={form.kelurahan}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kode Pos
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kode_pos"
                        value={form.kode_pos}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Warga Summarecon
                      </label>
                      <select
                        className="form-select"
                        name="warga_summarecon"
                        value={form.warga_summarecon}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">Pilih Status</option>
                        <option value="1">Ya</option>
                        <option value="0">Tidak</option>
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Jarak Rumah ke Sekolah
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="jarak_rumah_sekolah"
                        value={form.jarak_rumah_sekolah}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Waktu Tempuh ke Sekolah
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="waktu_tempuh_sekolah"
                        value={form.waktu_tempuh_sekolah}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Transportasi ke Sekolah
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ke_sekolah_dengan"
                        value={form.ke_sekolah_dengan}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* TAB 4: FISIK & KESEHATAN */}
            {activeTab === "kesehatan" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faHeartPulse} /> Kondisi Fisik & Riwayat Kesehatan
                </h6>
                <Row className="g-3">
                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Tinggi Badan (cm)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="tinggi"
                        value={form.tinggi}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Berat Badan (kg)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="berat"
                        value={form.berat}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Lingkar Kepala (cm)
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="linkar_kepala"
                        value={form.linkar_kepala}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Ukuran Sepatu
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="ukuran_sepatu"
                        value={form.ukuran_sepatu}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Penyakit yang Pernah Diderita
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="penyakit_diderita"
                        value={form.penyakit_diderita}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kelainan Jasmani
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kelainan_jasmani"
                        value={form.kelainan_jasmani}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Pernah Dirawat Di
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="pernah_dirawat_di"
                        value={form.pernah_dirawat_di}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* TAB 5: ASAL SEKOLAH */}
            {activeTab === "asal_sekolah" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faSchool} /> Informasi Sekolah Asal
                </h6>
                <Row className="g-3">
                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Status Sekolah Asal
                      </label>
                      <select
                        className="form-select"
                        name="sekolah_asal"
                        value={form.sekolah_asal}
                        onChange={handleChange}
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      >
                        <option value="">Pilih Kategori</option>
                        <option value="Siswa Baru">Siswa Baru</option>
                        <option value="Pindahan">Pindahan</option>
                      </select>
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Nama Sekolah Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="nama_sekolah_asal"
                        value={form.nama_sekolah_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Akreditasi Sekolah Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="akreditasi_sekolah_asal"
                        value={form.akreditasi_sekolah_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="12">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Alasan Pindah / Dari Sekolah Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="pindahan_dari_sekolah"
                        value={form.pindahan_dari_sekolah}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Provinsi Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="provinsi_asal"
                        value={form.provinsi_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kota / Kab. Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kota_kabupaten_asal"
                        value={form.kota_kabupaten_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kecamatan Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kecamatan_asal"
                        value={form.kecamatan_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kelurahan Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kelurahan_desa_asal"
                        value={form.kelurahan_desa_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="mb-3">
                      <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                        Kode Pos Asal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="kode_pos_asal"
                        value={form.kode_pos_asal}
                        onChange={handleChange}
                        placeholder="..."
                        style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                      />
                    </div>
                  </Col>

                  <Col md="12" className="mt-3">
                    <label className="form-label font-weight-bold mb-2" style={{ fontSize: "13px" }}>
                      Kelengkapan Dokumen Fisik Persyaratan
                    </label>
                    <Row>
                      {[
                        { name: "syarat_1", label: "Surat Keterangan Lulus / Ijazah" },
                        { name: "syarat_2", label: "Fotokopi Akta Kelahiran & KK" },
                        { name: "syarat_3", label: "Fotokopi KTP Kedua Orang Tua" },
                        { name: "syarat_4", label: "Pas Foto & Raport Terakhir" },
                      ].map((item) => (
                        <Col md="6" key={item.name} className="mb-2">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={"update_" + item.name}
                              name={item.name}
                              checked={Number(form[item.name]) === 1}
                              onChange={handleChange}
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={"update_" + item.name}
                              style={{ cursor: "pointer", fontSize: "13px" }}
                            >
                              {item.label}
                            </label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </div>
            )}

            {/* TAB 6: DATA ORANG TUA */}
            {activeTab === "orang_tua" && (
              <div>
                <div className="card border-0 shadow-sm rounded-3 p-4 mb-4 bg-white">
                  <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faUsers} /> Data Ayah Kandung
                  </h6>
                  <Row className="g-3">
                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Nama Lengkap Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="nama_lengkap_ayah"
                          value={form.nama_lengkap_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          NIK Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="nik_ayah"
                          value={form.nik_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Tempat Lahir Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="tempat_lahir_ayah"
                          value={form.tempat_lahir_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Tanggal Lahir Ayah
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="tanggal_lahir_ayah"
                          value={form.tanggal_lahir_ayah}
                          onChange={handleChange}
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Kewarganegaraan Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="kewarganegaraan_ayah"
                          value={form.kewarganegaraan_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Pendidikan Terakhir Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="pendidikan_terakhir_ayah"
                          value={form.pendidikan_terakhir_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Pekerjaan Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="pekerjaan_ayah"
                          value={form.pekerjaan_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Penghasilan Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="penghasilan_ayah"
                          value={form.penghasilan_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          No. Handphone Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="no_handphone_ayah"
                          value={form.no_handphone_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Email Ayah
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="alamat_email_ayah"
                          value={form.alamat_email_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Keterangan Ayah
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="keterangan_ayah"
                          value={form.keterangan_ayah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                  <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faUsers} /> Data Ibu Kandung
                  </h6>
                  <Row className="g-3">
                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Nama Lengkap Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="nama_lengkap_ibu"
                          value={form.nama_lengkap_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          NIK Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="nik_ibu"
                          value={form.nik_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Tempat Lahir Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="tempat_lahir_ibu"
                          value={form.tempat_lahir_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Tanggal Lahir Ibu
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="tanggal_lahir_ibu"
                          value={form.tanggal_lahir_ibu}
                          onChange={handleChange}
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Kewarganegaraan Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="kewarnegaraan_ibu"
                          value={form.kewarnegaraan_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Pekerjaan Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="pekerjaan_ibu"
                          value={form.pekerjaan_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Penghasilan Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="penghasilan_ibu"
                          value={form.penghasilan_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="4">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          No. Handphone Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="no_handphone_ibu"
                          value={form.no_handphone_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Email Ibu
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="alamat_email_ibu"
                          value={form.alamat_email_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Keterangan Ibu
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="keterangan_ibu"
                          value={form.keterangan_ibu}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            {/* TAB 7: INFORMASI LAIN */}
            {activeTab === "lainnya" && (
              <div>
                <div className="card border-0 shadow-sm rounded-3 p-4 mb-4 bg-white">
                  <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faStar} /> Prestasi, Bakat & Minat
                  </h6>
                  <Row className="g-3">
                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Bidang Akademik
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="bidang_akademik"
                          value={form.bidang_akademik}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Bidang Kesenian
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="kesenian"
                          value={form.kesenian}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Olahraga / Jasmani
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="pendidikan_jasmani"
                          value={form.pendidikan_jasmani}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="6">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Minat / Bakat Lain-lain
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="lain_lain"
                          value={form.lain_lain}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Saudara Kandung di Sekolah Ini
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="saudara_kandung_di_sekolah"
                          value={form.saudara_kandung_di_sekolah}
                          onChange={handleChange}
                          placeholder="..."
                          style={{ borderRadius: "8px", fontSize: "14px", height: "42px" }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                  <h6 className="font-weight-bold text-primary mb-3">
                    Sumber Informasi Mengenal Sekolah
                  </h6>
                  <Row>
                    {[
                      { name: "internet", label: "Internet / Media Sosial" },
                      { name: "spanduk", label: "Spanduk / Banner" },
                      { name: "billboard", label: "Billboard" },
                      { name: "pameran", label: "Pameran / Expo" },
                      { name: "rekomendasi_asal_sekolah", label: "Rekomendasi Asal Sekolah" },
                      { name: "teman", label: "Teman / Sahabat" },
                      { name: "keluarga", label: "Keluarga / Kerabat" },
                    ].map((item) => (
                      <Col md="4" sm="6" key={item.name} className="mb-2">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={"update_" + item.name}
                            name={item.name}
                            checked={Number(form[item.name]) === 1}
                            onChange={handleChange}
                            style={{ cursor: "pointer" }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={"update_" + item.name}
                            style={{ cursor: "pointer", fontSize: "13px" }}
                          >
                            {item.label}
                          </label>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            )}

            {/* TAB 8: UPLOAD BERKAS */}
            {activeTab === "berkas" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faFolderOpen} /> Unggah Berkas & Dokumen Siswa
                </h6>
                <p className="text-muted mb-4" style={{ fontSize: "13px" }}>
                  Silakan unggah dokumen yang diperlukan (format yang didukung: PDF, JPG, JPEG, PNG). Setiap berkas akan otomatis disimpan rapi ke folder masing-masing.
                </p>
                <Row className="g-3">
                  {DOC_FIELDS.map((doc) => (
                    <Col md="6" key={doc.name}>
                      <div
                        className="card h-100 border p-3"
                        style={{ borderRadius: "10px", backgroundColor: "#f8f9fa" }}
                      >
                        <div className="d-flex align-items-center mb-2">
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "8px",
                              backgroundColor: "#e8f0fe",
                              color: "#1a73e8",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "10px",
                              flexShrink: 0,
                            }}
                          >
                            <FontAwesomeIcon icon={faFilePdf} />
                          </div>
                          <div>
                            <h6 className="mb-0" style={{ fontSize: "14px", fontWeight: "600" }}>
                              {doc.label}
                            </h6>
                            <small className="text-muted" style={{ fontSize: "11px" }}>
                              {doc.desc}
                            </small>
                          </div>
                        </div>

                        {true && form[doc.name] && (
                          <div className="mb-2 p-2 bg-white rounded border d-flex align-items-center justify-content-between">
                            <small className="text-success text-truncate me-2" style={{ fontSize: "12px" }}>
                              <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                              Tersimpan: {String(form[doc.name]).split("/").pop()}
                            </small>
                            {process.env.REACT_APP_US && (
                              <a
                                href={`${process.env.REACT_APP_US}/storage/${form[doc.name]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary py-0 px-2"
                                style={{ fontSize: "11px" }}
                              >
                                Lihat
                              </a>
                            )}
                          </div>
                        )}

                        <div className="mt-auto">
                          <input
                            type="file"
                            id={doc.name}
                            name={doc.name}
                            className="form-control form-control-sm"
                            onChange={handleFileChange}
                            accept=".pdf,.jpg,.jpeg,.png"
                            style={{ fontSize: "12px", borderRadius: "6px" }}
                          />
                          {files[doc.name] && (
                            <small className="text-primary mt-1 d-block" style={{ fontSize: "11px" }}>
                              File dipilih: {files[doc.name].name} ({(files[doc.name].size / 1024).toFixed(1)} KB)
                            </small>
                          )}
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}

            {/* TAB 9: FOTO SISWA */}
            {activeTab === "foto" && (
              <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white">
                <h6 className="font-weight-bold text-primary mb-3 d-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faCamera} /> Foto Profil Siswa
                </h6>
                <Row className="align-items-center g-4">
                  <Col md="4" className="text-center">
                    <div
                      style={{
                        width: "180px",
                        height: "220px",
                        borderRadius: "12px",
                        border: "2px dashed #0d6efd",
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        backgroundColor: "#f8f9fa",
                        position: "relative",
                      }}
                    >
                      {photoPreview ? (
                        <img
                          src={photoPreview}
                          alt="Preview Foto Siswa"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div className="text-center text-muted p-3">
                          <FontAwesomeIcon icon={faCamera} size="3x" className="mb-2 text-primary" style={{ opacity: 0.6 }} />
                          <div style={{ fontSize: "12px" }}>Belum ada foto</div>
                        </div>
                      )}
                    </div>
                    {photoPreview && (
                      <div className="mt-2">
                        <span className="badge bg-primary" style={{ fontSize: "11px" }}>
                          {files.foto_siswa ? "Foto Baru Dipilih" : "Foto Saat Ini"}
                        </span>
                      </div>
                    )}
                  </Col>

                  <Col md="8">
                    <div className="p-3 bg-light rounded-3 border">
                      <h6 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px" }}>
                        Petunjuk Upload Foto Siswa
                      </h6>
                      <ul className="text-muted mb-3" style={{ fontSize: "12px", paddingLeft: "18px" }}>
                        <li>Format file foto yang didukung: <strong>JPG, JPEG, PNG, WEBP</strong></li>
                        <li>Gunakan foto formal/pasfoto dengan latar belakang polos dan wajah terlihat jelas</li>
                        <li>Ukuran maksimal berkas adalah <strong>5 MB</strong></li>
                        <li>Foto akan otomatis disimpan ke folder <code>foto_siswa</code> dengan penamaan terstandar sistem</li>
                      </ul>

                      <div className="mb-3">
                        <label className="form-label font-weight-bold" style={{ fontSize: "13px" }}>
                          Pilih Berkas Foto Siswa
                        </label>
                        <input
                          type="file"
                          name="foto_siswa"
                          className="form-control"
                          accept="image/jpeg,image/png,image/webp,image/jpg"
                          onChange={handlePhotoChange}
                          style={{ borderRadius: "8px", fontSize: "13px" }}
                        />
                      </div>

                      {files.foto_siswa && (
                        <div className="d-flex align-items-center justify-content-between p-2 bg-white rounded border">
                          <small className="text-success" style={{ fontSize: "12px" }}>
                            <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                            {files.foto_siswa.name} ({(files.foto_siswa.size / 1024).toFixed(1)} KB)
                          </small>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger py-0 px-2"
                            onClick={handleRemovePhoto}
                            style={{ fontSize: "11px" }}
                          >
                            <FontAwesomeIcon icon={faTrash} className="me-1" /> Hapus
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* MODAL FOOTER CONTROLS */}
            <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-4">
              <div>
                {activeTab !== "akademik" && (
                  <Button
                    type="button"
                    color="light"
                    className="border px-4 py-2"
                    onClick={handlePrevTab}
                    style={{ borderRadius: "8px", fontSize: "13px", fontWeight: "600" }}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Sebelumnya
                  </Button>
                )}
              </div>

              <div className="d-flex gap-2">
                <Button
                  type="button"
                  color="secondary"
                  className="px-4 py-2"
                  onClick={props.onHide}
                  style={{ borderRadius: "8px", fontSize: "13px", fontWeight: "600" }}
                >
                  Batal
                </Button>

                {activeTab !== "foto" ? (
                  <Button
                    type="button"
                    color="primary"
                    className="px-4 py-2"
                    onClick={handleNextTab}
                    style={{ borderRadius: "8px", fontSize: "13px", fontWeight: "600" }}
                  >
                    Selanjutnya <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    color="success"
                    className="px-4 py-2"
                    disabled={loading}
                    style={{ borderRadius: "8px", fontSize: "13px", fontWeight: "600" }}
                  >
                    <FontAwesomeIcon icon={faSave} className="me-2" /> Simpan Perubahan
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
